module.exports = __webpack_public_path__ + "static/media/quality-providers.767585eb.png";